import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentTitleService {
  private langChangeSubscription?: Subscription;

  constructor(
    private title: Title,
    private translate: TranslateService
  ) {}

  init(): void {
    if (this.langChangeSubscription) return;

    this.updateTitle();
    this.langChangeSubscription = this.translate.onLangChange.subscribe((_event: LangChangeEvent) => {
      this.updateTitle();
    });
  }

  private updateTitle(): void {
    const translatedTitle = this.translate.instant('app.title');
    this.title.setTitle(translatedTitle !== 'app.title' ? translatedTitle : 'Pipeup');
  }
}
